var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "ingredients";

var DEFAULTS = {
	target: ''
};

/**
 *
 * @param element
 * @param options
 * @constructor
 */
function Ingredients(element, options) {
	this.element = element;
	this.$t = $(this.element);
	this.$table = null;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.initialise_();
}

/**
 *
 * @private
 */
Ingredients.prototype.initialise_ = function() {
	if (this.options.target !== '') {
		this.$table = $(this.options.target);
	} else {
		return false;
	}

	this.servingsCount = this.$t.val();

	this.activateRowChecking_();
	this.preventAlphaChars_();
	this.activateIngredientsRecalc_();

};

/**
 *
 * @private
 */
Ingredients.prototype.activateRowChecking_ = function() {
	this.$table.on('click', 'td a', function(event) {
		event.stopPropagation();
	});
	this.$table.on('click', 'td', function(event) {
		event.preventDefault();
		$(event.currentTarget).parents('tr:first').toggleClass('checked');
	});
};

/**
 *
 * @private
 */
Ingredients.prototype.preventAlphaChars_ = function() {
	this.$t.on('keypress', function(event) {
		if ((event.which < 48 || event.which > 57) && event.which != 8 && event.which != 0) {
			event.preventDefault();
		}
	});
};

Ingredients.prototype.activateIngredientsRecalc_ = function() {
	var self_ = this;
	this.$t.on('change', function(event) {
		var value = $(event.currentTarget).val();
		$('tr', self_.$table).each(function(index, item) {
			self_.recalcRow_($(item), value);
		});
	});
};

Ingredients.prototype.recalcRow_ = function($row, newServingsCount) {
	var oneServingValue = $('td:first', $row).data('amount') / this.servingsCount;
	var unit = $('td:first', $row).data('unit');
	$('td:first', $row).empty().html(Math.round(oneServingValue*newServingsCount*100)/100 + '<small>'+unit+'</small>');
};

/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new Ingredients(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.ingredients.js